/* Ultimate PDP — variant picker, price sync, sticky bar, gallery dots.
   No dependencies. Safe to load on any theme. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var out = whole + '.' + parts[1];
    if (format && format.indexOf('amount_no_decimals') > -1) out = whole;
    return format ? format.replace(/\{\{\s*\w+\s*\}\}/, out) : '$' + out;
  }

  function initPdp(root) {
    if (!root || root.dataset.updReady === 'true') return;
    root.dataset.updReady = 'true';

    var dataEl = root.querySelector('[data-upd-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    var form = root.querySelector('[data-upd-form]');
    var idInput = root.querySelector('[data-upd-variant-id]');
    var priceEl = root.querySelector('[data-upd-price]');
    var wasEl = root.querySelector('[data-upd-compare]');
    var saveEl = root.querySelector('[data-upd-save]');
    var mainBtn = root.querySelector('[data-upd-add]');
    var stickyPrice = root.querySelector('[data-upd-sticky-price]');
    var stickyWas = root.querySelector('[data-upd-sticky-compare]');
    var ctaTemplate = mainBtn ? mainBtn.dataset.template || '' : '';
    var soldOutText = mainBtn ? mainBtn.dataset.soldOut || 'Sold out' : 'Sold out';

    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, moneyFormat);

      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl) {
        wasEl.textContent = hasCompare ? formatMoney(v.compare_at_price, moneyFormat) : '';
        wasEl.style.display = hasCompare ? '' : 'none';
      }
      if (stickyWas) {
        stickyWas.textContent = hasCompare ? formatMoney(v.compare_at_price, moneyFormat) : '';
        stickyWas.style.display = hasCompare ? '' : 'none';
      }
      if (saveEl) {
        if (hasCompare) {
          saveEl.textContent = (saveEl.dataset.label || 'Save') + ' ' +
            formatMoney(v.compare_at_price - v.price, moneyFormat);
          saveEl.style.display = '';
        } else {
          saveEl.textContent = '';
          saveEl.style.display = 'none';
        }
      }
      if (mainBtn) {
        mainBtn.disabled = !v.available;
        mainBtn.textContent = v.available
          ? ctaTemplate.replace('[price]', formatMoney(v.price, moneyFormat))
          : soldOutText;
      }
      root.dispatchEvent(new CustomEvent('upd:variant:change', { bubbles: true, detail: { variant: v } }));
    }

    // --- variant buttons ---
    var buttons = root.querySelectorAll('[data-upd-variant-btn]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(buttons, function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        var id = parseInt(btn.dataset.variantId, 10);
        var match = variants.filter(function (v) { return v.id === id; })[0];
        applyVariant(match);
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          history.replaceState({}, '', url.toString());
        }
      });
    });

    // --- sticky bar submits the real product form ---
    var stickyBtn = root.querySelector('[data-upd-sticky-add]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    // --- sticky bar reveal (FIXED) ---
    var sticky = root.querySelector('[data-upd-sticky]');
    var anchor = root.querySelector('[data-upd-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 }).observe(anchor);
    }

    // --- gallery dots + badge fade ---
    var track = root.querySelector('[data-upd-gallery]');
    var dots = root.querySelectorAll('[data-upd-dot]');
    var badge = root.querySelector('.upd-badge');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(dots, function (d, n) { d.classList.toggle('is-on', n === i); });
        if (badge) badge.style.opacity = i === 0 ? '1' : '0';
      }, { passive: true });
    }
  }

  function initVideos(scope) {
    var facades = (scope || document).querySelectorAll('[data-upd-video-facade]');
    Array.prototype.forEach.call(facades, function (btn) {
      if (btn.dataset.updBound === 'true') return;
      btn.dataset.updBound = 'true';
      btn.addEventListener('click', function () {
        var overlay = document.createElement('div');
        overlay.className = 'upd-video-overlay';

        var iframe = document.createElement('iframe');
        iframe.src = btn.dataset.embed;
        iframe.title = btn.dataset.title || 'Product video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');

        var closeBtn = document.createElement('button');
        closeBtn.className = 'upd-video-close';
        closeBtn.setAttribute('aria-label', 'Close video');
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('click', function () {
          document.body.removeChild(overlay);
        });

        overlay.appendChild(iframe);
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);
      });
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-upd-root]');
    Array.prototype.forEach.call(roots, initPdp);
    initVideos(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-init when the Theme Editor re-renders a section.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
